module.exports = __webpack_public_path__ + "static/media/advance_python.561dfc04.jpg";